// Electric Field Strength units with conversion factors to volt per meter (V/m)
export const electricFieldStrengthUnits = [
  { id: 'volt-per-meter', name: 'Volt/Meter', symbol: 'V/m', plural: 'Volts/Meter', factor: 1 },
  { id: 'kilovolt-per-meter', name: 'Kilovolt/Meter', symbol: 'kV/m', plural: 'Kilovolts/Meter', factor: 1000 },
  { id: 'kilovolt-per-centimeter', name: 'Kilovolt/Centimeter', symbol: 'kV/cm', plural: 'Kilovolts/Centimeter', factor: 100000 },
  { id: 'volt-per-centimeter', name: 'Volt/Centimeter', symbol: 'V/cm', plural: 'Volts/Centimeter', factor: 100 },
  { id: 'millivolt-per-meter', name: 'Millivolt/Meter', symbol: 'mV/m', plural: 'Millivolts/Meter', factor: 0.001 },
  { id: 'microvolt-per-meter', name: 'Microvolt/Meter', symbol: 'μV/m', plural: 'Microvolts/Meter', factor: 0.000001 },
  { id: 'volt-per-inch', name: 'Volt/Inch', symbol: 'V/in', plural: 'Volts/Inch', factor: 39.37007874 },
  { id: 'volt-per-mil', name: 'Volt/Mil', symbol: 'V/mil', plural: 'Volts/Mil', factor: 0.03937007874 },
  { id: 'abvolt-per-centimeter', name: 'Abvolt/Centimeter', symbol: 'abV/cm', plural: 'Abvolts/Centimeter', factor: 1e-6 },
  { id: 'statvolt-per-meter', name: 'Statvolt/Meter', symbol: 'statV/m', plural: 'Statvolts/Meter', factor: 299.792458 },
  { id: 'statvolt-per-centimeter', name: 'Statvolt/Centimeter', symbol: 'statV/cm', plural: 'Statvolts/Centimeter', factor: 29979.2458 },
  { id: 'newton-per-coulomb', name: 'Newton/Coulomb', symbol: 'N/C', plural: 'Newtons/Coulomb', factor: 1 },
];

export const popularElectricFieldStrengthConversions = [
  { from: 'volt-per-meter', to: 'kilovolt-per-meter' },
  { from: 'kilovolt-per-meter', to: 'volt-per-meter' },
  { from: 'volt-per-meter', to: 'volt-per-centimeter' },
  { from: 'volt-per-centimeter', to: 'volt-per-meter' },
  { from: 'kilovolt-per-centimeter', to: 'volt-per-meter' },
  { from: 'newton-per-coulomb', to: 'volt-per-meter' },
];

export const getUnitById = (id) => electricFieldStrengthUnits.find(unit => unit.id === id);

export const convertElectricFieldStrength = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert electric field strength units and learn the conversion formula.`;
};
